import Step from "@mui/material/Step"
import StepLabel from "@mui/material/StepLabel"
import Stepper, { Orientation } from "@mui/material/Stepper"
import { observer } from "mobx-react-lite"

export interface StepperStep {
   /** unique string - used for url/routing */
   id: string
   /** renders this view. If you want it to be rendered on demand, when the step is active, 
    * and destroyed when the step is made inactive, use a function component. Otherwise, if you
    * want it to be alive for the whole lifespan of the stepper, then use a react element */
   content: React.ReactElement | React.FunctionComponent
   sidebar?: React.ReactElement | React.FunctionComponent,
   hideNavigation?: boolean,
   /** the step's title */
   title: string
}

interface StepsProps {
   activeStepIndex: number
   steps: StepperStep[]
   orientation: Orientation
}

export const Steps = observer(function Steps(props: StepsProps) {
   return <Stepper activeStep={props.activeStepIndex} orientation={props.orientation}>
      {props.steps.map(step => (
         <Step key={step.id}>
            <StepLabel title={step.title}>
               {step.title}
            </StepLabel>
         </Step>
      ))}
   </Stepper>
})
